var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#471700",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M372.4 168.7s-33.3-26.1-72.7-29.1l-3.5 7.1c35.6 8.7 51.9 21.2 69 36.5-29.4-15-58.5-29.1-109.1-29.1s-79.7 14.1-109.1 29.1c17.1-15.3 36.5-29.2 69-36.5l-3.5-7.1c-41.3 3.9-72.7 29.1-72.7 29.1s-37.2 54-43.6 160c37.5 43.3 94.5 43.6 94.5 43.6l11.9-15.9c-20.2-7-43.1-19.6-62.8-42.3 23.5 17.8 59.1 36.4 116.4 36.4S349 332 372.6 314.1c-19.7 22.7-42.6 35.3-62.8 42.3l11.9 15.9s57-.3 94.5-43.6c-6.6-106-43.8-160-43.8-160zM208.7 299.6c-14.1 0-25.5-13-25.5-29.1s11.4-29.1 25.5-29.1 25.5 13 25.5 29.1-11.4 29.1-25.5 29.1zm94.6 0c-14.1 0-25.5-13-25.5-29.1s11.4-29.1 25.5-29.1 25.5 13 25.5 29.1-11.5 29.1-25.5 29.1z",
    fill: "#FFF"
  })));
}

export default SvgDiscord;